export default __webpack_public_path__ + "static/cc85d073-4dcf-4ecd-9804-40c34e631e2b-ce49a19c5ff96ab9c690b19fee16e037.woff2";